/**
 * 首页模块接口列表
 */

import base from "./base"; // 导入接口域名列表
import axios from "./http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const author = {
  getUserInfoToken() {
    return axios.get(`${base.fm}/user/token/get_info`);
  },
  //获取用户信息
  getUserInfo() {
    return axios.get(`${base.fm}/user/get_info`);
  },
  getWeixinJsApi(locaUrl) {
    let params = { test: 11 };
    return axios.post(
      `https://api.findmacau.com/fm/wechat/jsapi_ticket?url=` + locaUrl,
      qs.stringify(params)
    );
  },
  wxLoginFromPC(code) {
    let params = { code: code };
    return axios.post(`${base.fm}/auth/login/wechat`, qs.stringify(params));
  },
  fbLoginFromPC(
    account,
    password,
    nick_name,
    login_way,
    avatar_url,
    app_channel,
    access_token,
    openid,
    wechat_union_id,
    invitation_code
  ) {
    let params = {
      account: account,
      password: password,
      nick_name: nick_name ? nick_name : "",
      login_way: login_way,
      avatar_url: avatar_url,
      app_channel: app_channel,
      access_token: access_token,
      openid: openid,
      wechat_union_id: wechat_union_id,
      invitation_code: invitation_code
    };
    return axios.post(
      `${base.fm}/auth/login/third_platform`,
      qs.stringify(params)
    );
  },
  thirdBindFromPC(
    account,
    password,
    nick_name,
    login_way,
    avatar_url,
    app_channel,
    access_token,
    openid,
    wechat_union_id,
    invitation_code
  ) {
    let params = {
      account: account,
      password: password,
      nick_name: nick_name,
      login_way: login_way,
      avatar_url: avatar_url,
      app_channel: app_channel,
      access_token: access_token,
      openid: openid,
      wechat_union_id: wechat_union_id,
      invitation_code: invitation_code
    };
    return axios.post(
      `${base.fm}/auth/bind/third_platform`,
      qs.stringify(params)
    );
  }
};

export default author;



// WEBPACK FOOTER //
// ./src/api/author.js